import "./banner/Banner.css";
import Banner from "./banner/Banner";

function Home() {
  return (
    <>
      <Banner />      
    </>
  );
}

export default Home;
